import { Box, Image, Text, Center, useColorModeValue } from "@chakra-ui/react";
import pythoncert from "./images/pythoncert.jpg";
import djangocert from "./images/djangocert.jpg";
import nodecert from "./images/nodecert.png";

const Certifications = ({ dataSection }) => {
  const txtColor2 = useColorModeValue("black", "white");
  return (
    <Box p={{ base: "15px", lg: "70px" }}>
      <Text
        fontSize="3xl"
        color="teal.500"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        mt={{ base: "20px", lg: "0px" }}
      >
        Certifications
      </Text>

      <Text
        fontSize="sm"
        textAlign={{ base: "center", sm: "center", md: "center" }}
        color={txtColor2}
        mb={15}
      >
        Here are some of my certifications
      </Text>
      {/* <Box
        bg={{
          base: "red.400",
          sm: "blue.400",
          md: "green.400",
          lg: "orange.400",
        }}
      >
        good
      </Box> */}
      <Box
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection={{ base: "column", sm: "column", md: "row", lg: "row" }}
        gap={4}
        my={10}
      >
        <Box
          p="20px"
          bg="teal.800"
          borderRadius="20px"
          w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
          mb={{ base: "50px", lg: "0px" }}
        >
          <Box
            ml="auto"
            mr="auto"
            position={"relative"}
            h={{
              base: "300px",
              sm: "400px",
              md: "300px",
              lg: "400px",
              xl: "450",
              "2xl": "450px",
            }}
          >
            <Center>
              <Image
                w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
                borderRadius="20px"
                src={pythoncert}
              />
            </Center>
            <Box position={"absolute"} bottom="0">
              <Text color="#e6e6e6" fontSize="20px" mt="5px">
                Bootcamp Zero to Hero in Python
              </Text>
              <Text fontSize="sm" color="#e6e6e6">
                Issue by Udemy
              </Text>
              <Text fontSize="sm" color="#999999">
                Feb 2022
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          p="20px"
          bg="teal.800"
          borderRadius="20px"
          w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
          mb={{ base: "50px", lg: "0px" }}
        >
          <Box
            ml="auto"
            mr="auto"
            position={"relative"}
            h={{
              base: "300px",
              sm: "400px",
              md: "300px",
              lg: "400px",
              xl: "450",
              "2xl": "450px",
            }}
          >
            <Center>
              <Image
                w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
                src={djangocert}
                borderRadius="20px"
              />
            </Center>
            <Box position={"absolute"} bottom="0">
              <Text color="#e6e6e6" fontSize="20px" mt="5px">
                Django 4 and Python FullStack
              </Text>
              <Text fontSize="sm" color="#e6e6e6">
                Issue by Udemy
              </Text>
              <Text fontSize="sm" color="#999999">
                Mar 2022
              </Text>
            </Box>
          </Box>
        </Box>
        <Box
          p="20px"
          bg="teal.800"
          borderRadius="20px"
          w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
          mb={{ base: "50px", lg: "0px" }}
        >
          <Box
            ml="auto"
            mr="auto"
            position={"relative"}
            h={{
              base: "300px",
              sm: "400px",
              md: "300px",
              lg: "400px",
              xl: "450",
              "2xl": "450px",
            }}
          >
            <Center>
              <Image
                w={{ base: "250px", sm: "400px", md: "250px", lg: "500px" }}
                src={nodecert}
                borderRadius="20px"
              />
            </Center>
            <Box position={"absolute"} bottom="0">
              <Text color="#e6e6e6" fontSize="20px" mt="5px">
                Backend Web Dev using JavaScript and Node.js
              </Text>
              <Text fontSize="sm" color="#e6e6e6">
                Issue by DevTown
              </Text>
              <Text fontSize="sm" color="#999999">
                Mar 2023
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Certifications;
